/* Click-only desktop mega menus. Mobile navigation uses separate markup. */
(function () {
  const selector = '.navigation__menuitem--dropdown';
  const activeClass = 'navigation__menuitem--active';

  function items() {
    return Array.from(document.querySelectorAll(selector)).filter(function (item) {
      return item.querySelector(':scope > .megamenu');
    });
  }

  function triggerFor(item) {
    return item.querySelector(':scope > .navigation__menulink');
  }

  function setOpen(item, open) {
    item.classList.toggle(activeClass, open);
    item.setAttribute('aria-expanded', String(open));
    const trigger = triggerFor(item);
    if (trigger) trigger.setAttribute('aria-expanded', String(open));
  }

  function closeOthers(except) {
    items().forEach(function (item) {
      if (item !== except) setOpen(item, false);
    });
  }

  function toggle(item) {
    const open = !item.classList.contains(activeClass);
    closeOthers(item);
    setOpen(item, open);
  }

  function getTrigger(target) {
    const trigger = target.closest(selector + ' > .navigation__menulink');
    return trigger && trigger.parentElement.querySelector(':scope > .megamenu') ? trigger : null;
  }

  function init() {
    items().forEach(function (item) {
      const trigger = triggerFor(item);
      if (!trigger) return;
      trigger.setAttribute('aria-haspopup', 'true');
      setOpen(item, item.classList.contains(activeClass));
    });
  }

  document.addEventListener('click', function (event) {
    const trigger = getTrigger(event.target);
    if (trigger) {
    const item = trigger.parentElement;

    // Second click follows the menu item's link.
    if (item.classList.contains(activeClass)) {
        event.stopImmediatePropagation();
        return;
    }

    // First click opens the mega menu.
    event.preventDefault();
    event.stopImmediatePropagation();
    closeOthers(item);
    setOpen(item, true);
    return;
    }
    items().forEach(function (item) {
      if (!item.contains(event.target)) setOpen(item, false);
    });
  }, true);

  document.addEventListener('keydown', function (event) {
    const trigger = getTrigger(event.target);
    if (trigger && (event.key === 'Enter' || event.key === ' ')) {
      event.preventDefault();
      event.stopImmediatePropagation();
      if (!event.repeat) {
        const item = trigger.parentElement;

        if (event.key === 'Enter' && item.classList.contains(activeClass)) {
            window.location.assign(trigger.href);
        } else {
            toggle(item);
        }
      }
    } else if (event.key === 'Escape') {
      const open = items().find(function (item) {
        return item.classList.contains(activeClass);
      });
      if (!open) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      closeOthers();
      if (open.contains(document.activeElement)) triggerFor(open).focus();
    }
  }, true);

  document.addEventListener('focusin', function (event) {
    items().forEach(function (item) {
      if (!item.contains(event.target)) setOpen(item, false);
    });
  });

  document.addEventListener('shopify:section:load', init);
  init();
}());